var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      style: {
        height: _vm.canvasHeight + "px",
        width: _vm.canvasWidth + "px",
      },
      attrs: { id: "tourHandleInteractionMap" },
      on: {
        mousedown: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
        },
        touchstart: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
        },
      },
    },
    [
      _c("VTouch", {
        ref: "canvas",
        attrs: {
          tag: "canvas",
          width: _vm.canvasWidth,
          height: _vm.canvasHeight,
          "press-options": { time: 1 },
        },
        on: { pinchmove: _vm.checkPinch, press: _vm.checkSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }